import MarkerClusterGroup from "@changey/react-leaflet-markercluster";
import L from "leaflet";
import ConsolMarker from "./ConsolMarker.js";
import React, { useEffect, useRef } from "react";

export default function ConsolClusterIcon({ data, mapType }) {

  const createClusterCustomIcon = function (cluster) {
    var markers = cluster.getAllChildMarkers();
    var typeCounts = {
      boots_on: 0,
      boots_on_stale: 0,
      order: 0,
      clash_order: 0,
    };
    for (var i = 0; i < markers.length; i++) {
      var marker = markers[i];
      var typ = marker.options.markerType;

      typeCounts[typ]++;
      if (typ == "clash_order") {
        typeCounts["boots_on"] += marker.options.bootsOnCount;
        typeCounts["boots_on_stale"] += marker.options.bootsOnStaleCount;
        typeCounts["order"] += marker.options.noBootsCount;
      }
    }

    return L.divIcon({
      html: `<div class="markerCluster">
      <span style="color:#46841F">${typeCounts["boots_on"]}</span>
      <span style="color:#87BC64">${typeCounts["boots_on_stale"]}</span>
      <span style="color:#81A1E6">${typeCounts["order"]}</span>
      </div>`,
      className: "customMarker",
      iconSize: L.point(100, 40, true),
    });
  };

  return (
    <MarkerClusterGroup
      showCoverageOnHover={false}
      iconCreateFunction={createClusterCustomIcon}
    >
      {data.map((item, idx) => (
        <ConsolMarker key={idx} item={item} idx={idx} mapType={mapType} />
      ))}
    </MarkerClusterGroup>
  );
}
